export const KEY = 'relatedWebsites';

export const RELATED_WEBSITES = 'relatedWebsites';
export const RELATED_WEBSITES_STATUS = 'relatedWebsitesStatus';
export const EDITED_RELATED_WEBSITE = 'editedRelatedWebsite';
export const RELATED_WEBSITE_CREATE_STATUS = 'relatedWebsiteCreateStatus';
export const RELATED_WEBSITE_EDIT_STATUS = 'relatedWebsiteEditStatus';
export const RELATED_WEBSITE_DELETE_STATUS = 'relatedWebsiteDeleteStatus';
